/**
 * NAS 메일 아카이브 이관 API.
 *
 * 백엔드는 담당자(계정명 ksw) + 관리자에게만 열려 있다. 그 외에는 403 이 오므로
 * 화면은 available() 로 먼저 물어보고 메뉴 자체를 감춘다.
 */
import { api } from "../../../util/api";

const BASE = `${process.env.REACT_APP_API_BASE_URL}/mail-archive`;

export const archiveApi = {
    /** 메뉴 노출 여부 — 담당자·관리자·NAS 활성 여부를 서버가 한 번에 판단 */
    available:  ()            => api.get(`${BASE}/available`),

    /** DSM 로그인 + 공유폴더 조회까지 실제로 시도 */
    connection: ()            => api.get(`${BASE}/connection`),

    /** 폴더 탐색 — 경로 직접 입력 대신 이걸로 고른다(이모지 섞인 이름이 많다) */
    browse:     (path)        => api.get(`${BASE}/browse`, path ? { path } : {}),

    /**
     * 사용자 목록 조회 — ZIP 을 열어 계정·메일함별 건수와 직원 매칭을 낸다.
     *
     * 폴더 여러 개를 받아 `?path=A&path=B` 로 보낸다. 쿼리를 직접 조립하는 이유는,
     * axios 기본 직렬화가 배열을 `path[]=A&path[]=B` 로 만들어 Spring 의
     * `@RequestParam(name="path") List<String>` 에 <b>하나도 바인딩되지 않기</b> 때문이다
     * (에러가 아니라 '경로 미지정' 으로 조용히 넘어가 엉뚱한 결과가 나온다).
     */
    preview:    (paths)       => {
        const list = (paths || []).filter(Boolean);
        if (!list.length) return api.get(`${BASE}/preview`);
        const qs = new URLSearchParams();
        list.forEach(p => qs.append("path", p));
        return api.get(`${BASE}/preview?${qs.toString()}`);
    },

    /** 이관 시작. accountOverrides = { 계정ID: 직원id } 로 매칭을 교정할 수 있다 */
    start:      (body)        => api.post(`${BASE}/import`, body || {}),

    status:     (jobId)       => api.get(`${BASE}/import/status`, jobId ? { jobId } : {}),
    cancel:     (jobId)       => api.post(`${BASE}/import/cancel`, null, { params: jobId ? { jobId } : {} }),
};
